<template>
  <div>
    <van-popup v-model="show"  position="bottom">
      <slot></slot>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
      show: false
    }
  }
}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/popup/index.vue